import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "property-form-section" }
const _hoisted_2 = { class: "property-form-section-title text-overline text-medium-emphasis" }
const _hoisted_3 = {
  key: 0,
  class: "text-body-2 text-medium-emphasis"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_code_text = _resolveComponent("ontos-code-text")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
    (_ctx.explain)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
          _createVNode(_component_ontos_code_text, { text: _ctx.explain }, null, 8, ["text"])
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
}